import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Set this context token to true to opt out of global HTTP loader.
 */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export function skipGlobalLoaderContext(): { context: HttpContext } {
  return { context: new HttpContext().set(SKIP_GLOBAL_LOADER, true) };
}
